import DataServiceSQL from "../DataService/DataServiceSQL.js";

//Function to search for correspondant
const get_Correspondant = async (rpps, id_user) => {
    //console.log("Get Profile Information");
    return await DataServiceSQL.Correspondant_Research(rpps, id_user)
      .then(response => {
          //console.log("research result:")
          //console.log(response)
          return(response.data);
      })
      .catch(e => {
        console.log(e);
      });
};

//Function to register correspondant
const register_Correspondant = async (data, rpps, id_patient) => {
    //console.log("Get Profile Information");
    let data_to_register = data;
    data_to_register.rpps = rpps;
    data_to_register.id_patient = id_patient;
    return await DataServiceSQL.Correspondant_Register(data_to_register)
      .then(response => {
          //console.log("research result:")
          //console.log(response)
          return(response.data);
      })
      .catch(e => {
        console.log(e);
      });
};

//Function to dissociate correspondant
const dissociate_Correspondant = async (FK_structure, data) => {
  let send = {}

  send.FK_correspondant = null;
  send.serialNumber = data.Patient_Data.id_patient;
  send.group = data.Patient_Data.group;
  send.monitoring_activation = data.Patient_Data.monitoring_activation;
  send.alerts = data.Patient_Data.alerts;
  send.devices = data.Patient_Data.devices;

  //TMP: removed to withdraw route updatePatientDeviceGatewayReq
/*  return await DataServiceSQL.updatePatientDeviceGatewayReq(FK_structure, send)
    .then(response => {
      //console.log("research result:")
      //console.log(response)
      return(response.data);
    })
    .catch(e => {
      console.log(e);
    });
    */
    return false
};

//Const to import functions in other files
const CorrespondantGetter = {
  dissociate_Correspondant,
  get_Correspondant,
  register_Correspondant
};

export default CorrespondantGetter;